<div class="chat-container" [class.open]="isOpen" *ngIf="userService.hasAIChatAccess$ | async">

  <!-- Toggle Button -->
  <button mat-fab color="primary" class="chat-toggle" (click)="toggleChat()" matTooltip="AI Chat Assistant">
    <mat-icon>{{ isOpen ? 'close' : 'psychology' }}</mat-icon>
  </button>

  <!-- Chat Panel -->
  <mat-card class="chat-panel" *ngIf="isOpen">
    <mat-card-header>
      <div mat-card-avatar class="ai-avatar">
        <mat-icon>psychology</mat-icon>
      </div>
      <mat-card-title>AI Assistant</mat-card-title>
      <mat-card-subtitle>Invoice #{{ invoiceNumber }}</mat-card-subtitle>
      <div class="header-actions">
        <button mat-icon-button (click)="toggleHistory()" [matTooltip]="showHistory ? 'Back to chat' : 'Chat history'" [color]="showHistory ? 'primary' : ''">
          <mat-icon>history</mat-icon>
        </button>
        <button mat-icon-button (click)="startNewChat()" matTooltip="New Chat" [disabled]="isGenerating">
          <mat-icon>add_comment</mat-icon>
        </button>
      </div>
    </mat-card-header>

    <mat-divider></mat-divider>

    <!-- History Panel -->
    <mat-card-content class="history-panel" *ngIf="showHistory">
      <div class="history-empty" *ngIf="sessionHistory.length === 0">
        <mat-icon>chat_bubble_outline</mat-icon>
        <p>No previous chats found.</p>
      </div>
      <div class="history-list" *ngIf="sessionHistory.length > 0">
        <!-- Keyboard-operable in place: Enter and Space do what a click does, and Space must not also scroll the page. -->
        <div class="history-item"
             *ngFor="let session of sessionHistory"
             role="button"
             tabindex="0"
             (click)="selectHistorySession(session)"
             (keydown.enter)="selectHistorySession(session)"
             (keydown.space)="$event.preventDefault(); selectHistorySession(session)">
          <div class="history-item-header">
            <span class="history-creator">{{ session.created_by_name || 'Unknown' }}</span>
            <span class="history-date">{{ session.created_at | date:'dd.MM.yyyy' }}</span>
          </div>
          <div class="history-model">{{ session.model_id }}</div>
          <div class="history-preview" *ngIf="session.last_message">{{ session.last_message }}</div>
        </div>
      </div>
    </mat-card-content>

    <!-- Chat View -->
    <ng-container *ngIf="!showHistory">
      <mat-card-content class="message-list" #scrollContainer>
        <div class="welcome-message" *ngIf="messages.length === 0 && !currentStreamedText">
          <p>Hello! I'm your AI assistant for factoring evaluation.</p>
          <p>I can help you analyze this invoice, the client, or the end customer's payment history.</p>
        </div>

        <div *ngFor="let msg of messages" class="message-wrapper" [class.user]="msg.role === 'user'" [class.ai]="msg.role === 'model'">
          <div class="message-bubble">
            <div class="message-content" *ngIf="msg.role === 'user'">{{ msg.content }}</div>
            <markdown class="message-content" *ngIf="msg.role !== 'user'" [data]="msg.content"></markdown>
            <div class="message-footer" *ngIf="msg.tool_name">
              <mat-icon class="tool-icon">api</mat-icon> Used tool: {{ msg.tool_name }}
            </div>
          </div>
        </div>

        <!-- Streaming Message -->
        <div class="message-wrapper ai" *ngIf="currentStreamedText">
          <div class="message-bubble">
            <markdown class="message-content" [data]="currentStreamedText"></markdown><span class="cursor">|</span>
          </div>
        </div>

        <!-- Thinking Indicator / Tool Usage -->
        <div class="thinking-indicator" *ngIf="isGenerating && !currentStreamedText">
          <mat-progress-spinner mode="indeterminate" [diameter]="20"></mat-progress-spinner>
          <span class="status-text">{{ toolUsageStatus || 'Thinking...' }}</span>
        </div>
      </mat-card-content>

      <mat-divider></mat-divider>

      <mat-card-footer class="chat-footer">
        <!-- View-only indicator for other users' sessions -->
        <div class="view-only-banner" *ngIf="isViewOnly">
          <mat-icon>visibility</mat-icon>
          <span>View only — started by {{ activeSession?.created_by_name }}</span>
        </div>

        <ng-container *ngIf="!isViewOnly">
          <div class="model-selection" *ngIf="!activeSession">
            <mat-form-field appearance="outline" class="model-picker">
              <mat-label>AI Model</mat-label>
              <mat-select [(value)]="selectedModelId" [disabled]="isGenerating">
                <mat-option *ngFor="let model of models" [value]="model.id" [disabled]="!model.available">
                  {{ model.display_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="active-model-hint" *ngIf="activeSession">
            Using {{ activeSession.model_id }}
          </div>

          <div class="input-area">
            <mat-form-field appearance="outline" class="message-input">
              <textarea matInput
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="4"
                        placeholder="Ask a question..."
                        [(ngModel)]="currentInput"
                        [disabled]="isGenerating"
                        (keydown.enter)="$event.preventDefault(); sendMessage()"></textarea>
            </mat-form-field>
            <button mat-icon-button color="primary" [disabled]="isGenerating || !currentInput.trim()" (click)="sendMessage()">
              <mat-icon>send</mat-icon>
            </button>
          </div>
        </ng-container>
      </mat-card-footer>
    </ng-container>
  </mat-card>
</div>
